/*
 * Copyright (c) 2019 LNBIG.com
 * All rights reserved.
 */

import glue          from "../CommandGlue"
import dbg           from "debug"
import injectCaptcha from "./injectCaptcha"

const debug = dbg('lnbig:store:chat')
const MAX_MESSAGES = 10

let obj = {
    namespaced: true,
    state: {
        messages: [],
        nick: '',
        chatLoaded: false
    },
    mutations: {
        cmdChatStarted(state, message) {
            glue.find(
                'cmdChatStarted',
                message,
                (message, component) => {
                    debug("cmdChatStarted result: %o", message)
                    if (message.messages.length > 0) {
                        for (let i = 0; i < 10; i++) {
                            state.messages.unshift(message.messages[message.messages.length - i - 1])
                            if (i >= message.messages.length - 1)
                                break
                        }
                    }
                    state.chatLoaded = true
                }
            )
        },
        changeNick(state, nick) {
            state.nick = nick
        },
        resetChat(state) {
            state.chatLoaded = false
            state.messages.splice(0)
        },
        cmdNewMessage(state, message) {
            state.messages.push(message)
            if (state.messages.length > MAX_MESSAGES)
                state.messages.splice(0, state.messages.length - MAX_MESSAGES)
        }
    },
    actions: {
        async startChat({rootState, dispatch, commit}, component) {
            let promise

            try {
                commit('resetChat')
                if (!rootState.webSocket && rootState.webSocketError) {
                    throw new Error(rootState.webSocketError)
                }
                if (! rootState.helloPromise)
                    throw new Error("Non-standard error: hello handshake was not made but should be");
                await rootState.helloPromise

                // Распознаём текущий трафик бот/не_бот
                // Этот actRecaptchaV3 был внесён через injectCaptcha

                if (! await dispatch('actRecaptchaV3')) {
                    throw new Error("You defined as bot. Sorry but you cannot open a channel here")
                }

                debug('успешно прошли капчу')

                promise = glue.add(
                    (uuid) => {
                        rootState.webSocket.sendObj({
                            uuid,
                            command: 'cmdStartChat',
                            namespace: 'chat'
                        });

                        debug('Послали команду cmdStartChat на сервер')
                    },
                    'cmdChatStarted',
                    component
                )
            }
            catch (e) {
                component.serverError = e.message
            }
            return promise
        },

        async sendMessage({state, rootState}, messageText) {
            if (!rootState.webSocket && rootState.webSocketError) {
                throw new Error(rootState.webSocketError)
            }

            rootState.webSocket.sendObj({
                command: 'cmdNewMessage',
                namespace: 'chat',
                nick: state.nick,
                text: messageText
            })

        }

    }
}

obj = injectCaptcha(obj, 'chat', 'chat')

debug('После injectCaptcha, chat: %o', obj)

export default obj
